<accredible-content-header
  *transloco="let t; read: 'checkout-header'"
  [v1BackNavigation]="backNavigation"
  [withBreadcrumbs]="false"
  [title]="t(subscribed() ? 'customize_plan' : 'purchase_plan')">
  <div contentHeaderActions class="explore">
    <div class="font-normal-regular">
      {{ t('more_features') }}
    </div>
    <div class="font-normal-regular">
      <a
        accredible-link
        data-cy="link-explore-plans"
        href="https://www.accredible.com/pricing"
        target="_blank">
        {{ t('explore_plans') }}
      </a>
    </div>
  </div>

  @if (!subscribed()) {
    <div contentHeaderFilters>
      <accredible-wizard [steps]="steps" [currentStep]="0" />
    </div>
  }
</accredible-content-header>
